import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LinkUtils } from '@atlassian/mpac-utils';
import React, { PureComponent } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default class WithTargetForAllLinks extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "linksContainerEle", void 0);
    _defineProperty(this, "render", () => /*#__PURE__*/_jsx("div", {
      ref: linksContainerEle => this.linksContainerEle = linksContainerEle,
      style: this.props.extraStyle,
      children: this.props.children
    }));
  }
  componentDidMount() {
    LinkUtils.setTargetForAllLinks(this.linksContainerEle, this.props.target);
  }
  componentDidUpdate() {
    LinkUtils.setTargetForAllLinks(this.linksContainerEle, this.props.target);
  }
}